import { createSlice } from "@reduxjs/toolkit";

export const jaguarSlice = createSlice({
  name: "jaguar",
  initialState: {
    denuncia: {
      id: "1234dasd",
    },
    reports: [],
    filtredReports: [],
    filterApplied: false,
    fromUrl: null,
    currentReport: {
      reportDetail: null,
      users: { raw: [], formatted: [] },
      me: { raw: {}, formatted: {} },
      relativeFields: {},
      investigation: {
        id: null,
        name: null,
        involvedsInfo: { raw: [], formatted: [] },
        involvedsAccompliceInfo: { raw: [], formatted: [] },
        involvedsOffenderInfo: { raw: [], formatted: [] },
        involvedsVictimInfo: { raw: [], formatted: [] },
        involvedsWitnessInfo: { raw: [], formatted: [] },
        humanResourcesInfo: {
          raw: [],
          formatted: [],
          approved: [],
          approvedFormatted: [],
        },
        accessResourcesInfo: {
          raw: [],
          formatted: [],
          approved: [],
          approvedFormatted: [],
        },
        financialResourcesInfo: {
          raw: [],
          formatted: [],
          approved: [],
          approvedFormatted: [],
        },
        materialResourcesInfo: {
          raw: [],
          formatted: [],
          approved: [],
          approvedFormatted: [],
        },
      },
    },
  },
  reducers: {
    setFromUrl: (state, { payload }) => {
      state.fromUrl = payload;
    },
  },
});

export const { setFromUrl } = jaguarSlice.actions;
